"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculatePerSet = void 0;
var _constants = require("../constants");
/**
 * Calculating number of elements in slide set.
 * For example:
 * If 3 and a half elements are visible on page, 3 will be return as a number of elements in set
 * and scroll will move 3 by 3 elements.
 * On screens LG+ the set is 5 elements and we scroll by 5 regardless of available space.
 */
const calculatePerSet = ({
  minRequiredForFive
}) => {
  if (minRequiredForFive) {
    return _constants.itemsPerSet;
  }
  const viewPortWidth = window.innerWidth;
  if (viewPortWidth < _constants.smallSlideRange) {
    return 1;
  }
  return Math.floor(viewPortWidth / _constants.smallSlideRange);
};
exports.calculatePerSet = calculatePerSet;
